import dynamic from 'next/dynamic'

import { createModal } from '@/components/modalize'

import Loading from './loading'

const FiltersModal = dynamic(() => import('./base'), {
  ssr: false,
  loading: () => {
    return <Loading />
  }
})

export const show = createModal(FiltersModal, {
  width: '100%',
  maxWidth: '610px',
  showClose: false
})
